module.exports = __webpack_public_path__ + "media/flat/alipay-2031a3e2.svg";